import { Component } from '@angular/core';
import { Planner } from '@authority-labs/api-interfaces';
import { PlannerDialogService } from '@check-list/app/shared';
import { PlannersService } from '../planners.service';

@Component({
  selector: 'authority-labs-select-planner-dialog',
  templateUrl: './select-planner-dialog.component.html',
  styleUrls: ['./select-planner-dialog.component.scss']
})
export class SelectPlannerDialogComponent {
  title = 'מתכנן';
  searchFields = ['id', 'name', 'officeName', 'email', 'address', 'phone'];

  getLabel(planner: Planner): string {
    return planner ? planner.name : '';
  }

  constructor(
    public service: PlannersService,
    public plannerDialogService: PlannerDialogService
  ) {}
}
